let TOURNAMENT_INITED = false;

/**
 * Initializes the cashier module
 * @param {HTMLElement} element - The element that needs to be controlled
 */
function initializeTournament(element) {
  if (!TOURNAMENT_INITED) {
    TOURNAMENT_INITED = true;

    // Handle click event on the element
    element?.addEventListener('click', async (event) => {
      const isGame = event.target.closest('.js-game-popup'),
        isBack = event.target.closest('.js-game-back-button');

      console.log('click', isBack, isGame);

      if (!isGame && !isBack) return;
      if (isBack) event.stopPropagation();
      window.dispatchEvent(new Event('GAME_SIDEBAR_UPDATE'));
      element.classList.remove('active');

      if (isGame) {
        document.querySelector('.js-gamepopup-v4 .close').click();
        await new Promise((r) => setTimeout(r, 1000));
      }
    });
  }
  // window.dispatchEvent(new Event("resize"));
}

export { initializeTournament };
